import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledAccordion = styled(Accordion)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  border: "1px solid #ebebf7",
  "&.MuiAccordion-root": {
    borderRadius: "8px",
    height: "100%",
    minHeight: 0,
  },
  "& .MuiAccordion-region": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },
  "& .MuiCollapse-root": {
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  "& .MuiCollapse-hidden": {
    flex: "0 0 auto",
    height: "0 !important",
  },
  "& .MuiCollapse-entered": {
    flex: 1,
    minHeight: 0,
  },
  "& .MuiCollapse-wrapper": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },
  "& .MuiCollapse-wrapperInner": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },
});

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: 48,
  svg: {
    color: "#363846",
  },
  "&.Mui-expanded": {
    minHeight: 48,
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: theme.spacing(1, 0),
    alignItems: "center",
  },
  "& .MuiAccordionSummary-content": {
    margin: theme.spacing(1, 0),
    alignItems: "center",
  },
  "& p": {
    fontSize: 16,
  },
  [theme.breakpoints.down("xl")]: {
    height: 36,
    "&.Mui-expanded": {
      minHeight: 36,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: theme.spacing(1, 0),
    },
    "& p": {
      fontSize: 14,
      lineHeight: 1,
    },
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  borderTop: "1px solid #ebebf7",
  minHeight: 0,
  flex: 1,
  display: "flex",
  flexDirection: "column",
}));
